import React from "react";

type Props = {
  width: number;
  height: number;
};

export const IconChatSVG: React.FC<Props> = (props) => {
  const { width, height } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 54 54`}
    >
      <g transform="translate(7.895 1)">
        <rect
          width="54"
          height="54"
          transform="translate(-7.895 -1)"
          opacity="0"
        />
        <g transform="translate(-0.592 9.053)">
          <g>
            <path
              d="M39.329,33.835l-1.8-5.4a1.2,1.2,0,0,1,.08-.928,14.078,14.078,0,0,0-8-19.777,16.789,16.789,0,0,1,.989,9.539A16.505,16.505,0,0,1,17.341,30.393a17.12,17.12,0,0,1-2.6.253,14.064,14.064,0,0,0,16.715,2.995,1.192,1.192,0,0,1,.923-.077l5.419,1.807a1.215,1.215,0,0,0,1.536-1.536"
            />
            <path
              d="M11.609.252A14.075,14.075,0,0,0,1.785,20.509a1.2,1.2,0,0,1,.079.928l-1.8,5.4A1.214,1.214,0,0,0,1.6,28.371l5.419-1.806a1.2,1.2,0,0,1,.923.076A14.088,14.088,0,1,0,11.609.252m3.584,18.213h-7a1.25,1.25,0,0,1,0-2.5h7a1.25,1.25,0,1,1,0,2.5m5-5h-12a1.25,1.25,0,0,1,0-2.5h12a1.25,1.25,0,0,1,0,2.5"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
